import clsx from 'clsx';
import { useId, useState } from 'react';

import type { ChangeEvent } from 'react';

import styles from './CheckboxButton.module.css';

export interface CheckboxButtonProps {
  label: string;
  value: string;
  /** to set default status */
  isChecked?: boolean;
  /** The button variant. */
  variant?: 'single' | 'start' | 'middle' | 'end';
  /** `true` to disable the button; otherwise, `false`. The default is `false`. */
  disabled?: boolean;
  /** if set border becomes red */
  notValid?: boolean;
  /** The callback function that is invoked when the checkbox button changes value. */
  onSetValue: (value: string | null) => void;
}

/** Represents a component that acts as a checkbox, it's either set or unset. */
export const CheckboxButton = ({
  label,
  value,
  isChecked = false,
  variant = 'single',
  disabled,
  notValid,
  onSetValue,
}: CheckboxButtonProps) => {
  const idPrefix = useId();
  const [checked, setChecked] = useState(isChecked);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    onSetValue(event.target.checked ? event.target.value : null);
  };

  return (
    <span className={styles['checkbox-button__container']}>
      <input
        type="checkbox"
        id={`${idPrefix}${label}`}
        disabled={disabled}
        value={value}
        checked={checked}
        onChange={handleChange}
      />
      <label
        htmlFor={`${idPrefix}${label}`}
        className={clsx(styles['checkbox-button'], styles[`checkbox-button--${variant}`], {
          [styles['checkbox-button--not-valid']]: notValid,
        })}
      >
        {label}
      </label>
    </span>
  );
};
